import roundAndReturnString from "../../../../objects/CommonUse/round_and_return_string";
import getCurrentPriceArr from "../../xMoneyBuilderObjects/get_current_price_arr";

export const calculateTotalSavings = (savingsArr, gameNbrMonths, inputSavingsClass) => {
    if (!inputSavingsClass){
        inputSavingsClass = "all";
    }
    let currentPriceArr = [];
    if (gameNbrMonths && gameNbrMonths !== "") {
        if (inputSavingsClass === "all" || inputSavingsClass === "retirement"){
            currentPriceArr = getCurrentPriceArr(gameNbrMonths);
        }
    }
    let grandTotalSavings = 0;
    let totalMonthlyAmt = 0;
    let totalInterestEarned = 0;
    let totalDepositAmt = 0;
    let totalTransferAmt = 0;
    let totalMatchAmt = 0;
    let totalBeforeMatchAmt = 0;
    let totalMatchDepositAmt = 0;
    let returnArr = [];
    for (let i=0; i<savingsArr.length; i++){
        const savingsData = savingsArr[i];
        if (savingsData.closedDate === ""){
            const savingsType = savingsData.savingsType;
            const savingsClass = savingsData.savingsClass;
            if (savingsClass === inputSavingsClass ||  inputSavingsClass === "all"){
                const totalObj = savingsData.savingTotals;
                let currentMatchAmt = 0;
                let currentBeforeMatchAmt = 0;
                let currentTotalSavings = +totalObj.totalSavings;
                if (savingsData.savingsClass === "retirement"){
                    let currentPrice = 0;
                    const currentPriceObj = currentPriceArr.find(elem => elem.retirementType === savingsType);
                    if (currentPriceObj){
                        currentPrice = currentPriceObj.currentPrice;
                    }
                    currentTotalSavings = 
                        ((+totalObj.totalMatchQty + +totalObj.totalDepositQty) * currentPrice).toFixed(4);
                    currentMatchAmt = (+totalObj.totalMatchQty * currentPrice).toFixed(4);
                    currentBeforeMatchAmt = (+totalObj.totalDepositQty * currentPrice).toFixed(4);
                }
                //const totalIndx = returnArr.findIndex(elem => elem.savingsType === savingsType);
                //  the following is done to consolidate all CD accounts into a single total record
                let totalSavingsObj = {savingsClass: savingsClass, 
                    savingsType: savingsType, 
                    totalSavings: +currentTotalSavings,
                    totalDeposit: +totalObj.totalDeposit, 
                    totalInterest: +totalObj.totalInterest, 
                    totalTransferAmt: totalObj.totalTransferAmt, 
                }
                if (savingsClass === "retirement"){
                    totalSavingsObj = {...totalSavingsObj, 
                        totalMatchAmt: +currentMatchAmt, 
                        totalMatchQty: +totalObj.totalMatchQty, 
                        totalMatchDeposits: +totalObj.totalMatchDeposits,
                        totalBeforeMatchAmt: +currentBeforeMatchAmt,
                        totalShareQty: +totalObj.totalMatchQty};
                }    
                returnArr.push(totalSavingsObj);
                grandTotalSavings += +currentTotalSavings;
                totalMonthlyAmt += +savingsData.monthlyDepositAmt;
                totalInterestEarned += +totalObj.totalInterest;
                totalDepositAmt += +totalObj.totalDeposit;
                totalTransferAmt += +totalObj.totalTransferAmt;
                if (savingsClass === "retirement"){
                    totalMatchDepositAmt += +totalObj.totalMatchDeposits;
                    totalMatchAmt = +totalMatchAmt + +currentMatchAmt;
                    totalBeforeMatchAmt = +totalBeforeMatchAmt + +currentBeforeMatchAmt;
                }             
            }
        }
    }
    grandTotalSavings = roundAndReturnString(grandTotalSavings);
    const returnObj = {totalSavingsArr: returnArr, totalSavings: (+grandTotalSavings).toFixed(2),
        totalMonthlyAmt: totalMonthlyAmt, totalInterestEarned: totalInterestEarned.toFixed(4),
        totalDeposited: totalDepositAmt, totalTransferAmt: totalTransferAmt, 
        totalMatchAmt: totalMatchAmt, totalMatchDepositsAmt: (+totalMatchDepositAmt).toFixed(2),
        totalBeforeMatchAmt: totalBeforeMatchAmt
    };
    return returnObj; 
}

export default calculateTotalSavings;